import { render, staticRenderFns } from "./SessionForm.vue?vue&type=template&id=5410fd32"
import script from "./SessionForm.vue?vue&type=script&lang=js"
export * from "./SessionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports